import { Button, useTheme } from '@mui/material';
import { ArrowLeftIcon } from 'request-form-lib';

export type BackActionButtonProps = {
    /** Click handler. */
    onClick: () => void;
    /** Optional override for the label. Defaults to "Späť". */
    label?: string;
    /** Disable while a primary action is running. */
    disabled?: boolean;
};

/**
 * Secondary action button used in magic-link action bars.
 *
 * Styling: outlined variant with a gray border and a **black** text label and icon
 * (per design). The button stretches to fill its parent column so it cooperates with
 * the 50/50 mobile layout in `MagicLinkActionBar`.
 */
const BackActionButton = ({ onClick, label = 'Späť', disabled }: BackActionButtonProps) => {
    const theme = useTheme();

    return (
        <Button
            variant="outlined"
            size="large"
            fullWidth
            onClick={onClick}
            disabled={disabled}
            startIcon={
                <ArrowLeftIcon width={18} height={18} color={theme.palette.text.primary} />
            }
            sx={{
                textTransform: 'none',
                color: theme.palette.text.primary,
                borderColor: theme.palette.divider,
                height: '55px',
                width: 'fit-content',
                fontWeight: 500,
                '&:hover': {
                    borderColor: theme.palette.text.primary,
                    backgroundColor: theme.palette.action.hover,
                },
            }}
        >
            {label}
        </Button>
    );
};

export default BackActionButton;
